import { MediaObjectUpload, SignedUploadField } from '@kudos/http-client'
import { useCallback } from 'react'

export const useMediaUpload = () => {
  const handleMediaUpload = useCallback(
    ({
      initiateUploadResponse,
      file,
    }: {
      initiateUploadResponse: MediaObjectUpload
      file: File
    }) => {
      const uploadFields = initiateUploadResponse.upload.fields
      const mediaObjectId = initiateUploadResponse.mediaObject.id
      const mediaObjectUrl = new URL(initiateUploadResponse.mediaObject.url).href
      const uploadUrl = new URL(initiateUploadResponse.upload.url).href

      const awsFormData = new FormData() // 'multipart/form-data' constructor

      uploadFields.forEach(([key, value]: SignedUploadField) => {
        awsFormData.append(key, value)
      })
      awsFormData.append('file', file)

      return { awsFormData, mediaObjectId, uploadUrl, mediaObjectUrl }
    },
    [],
  )

  return { handleMediaUpload }
}
